'use strict';

var React = require('react');

var SvgMetafieldsMinor = function SvgMetafieldsMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M4 4.5a1.5 1.5 0 0 1 1.5-1.5h2a1.5 1.5 0 0 1 1.5 1.5v.5h2v-.5a1.5 1.5 0 0 1 1.5-1.5h2a1.5 1.5 0 0 1 1.5 1.5v.768a2 2 0 0 1 1 1.732v3h-14v-3a2 2 0 0 1 1-1.732v-.768Zm-1 7.5h14v3a2 2 0 0 1-2 2h-10a2 2 0 0 1-2-2v-3Z"
  }));
};

exports.SvgMetafieldsMinor = SvgMetafieldsMinor;
